import { colors, grayScale } from '../ui/inline-styles/variables';

export const indexToColor = (index: number | null): string => {
  const indexToColorMap: string[] = [colors.green, colors.yellowL, colors.yellowM, colors.yellowD, colors.red];

  return index != null && indexToColorMap[index] ? indexToColorMap[index] : grayScale['5'];
};



// WEBPACK FOOTER //
// ./src/app/utils/index-to-color.util.ts